import React from 'react'
import classNames from 'classnames'
import styles from './popmenu.module.less'

const leftHandClass = classNames(
  styles.img,
  styles.handImage,
  styles.handImageLeft
)
const rightHandClass = classNames(
  styles.img,
  styles.handImage,
  styles.handImageRight
)
const robotClass = classNames(styles.img, styles.robotImage)

const showRobot = location.hostname.includes('mendian')
const PopRobot = () => {
  if (!showRobot) {
    return null
  }
  return (
    <>
      <img
        className={leftHandClass}
        src={require('../assets/comm_icon_hand_left.png')}
        alt="小手"
      />
      <img
        className={rightHandClass}
        src={require('../assets/comm_icon_hand_right.png')}
        alt="小手"
      />
      <img
        className={robotClass}
        src="//pic3.58cdn.com.cn/nowater/fangfe/n_v2f2d142bf5a62409c9d83509cab903efb.png"
        alt="机器人"
      />
    </>
  )
}

export { PopRobot }
